import { dispatch, UPDATE_CART_ITEMS_COUNT, useSubscribeTo, } from '@redbubble/next-events';
import { useMemo, useState } from 'react';
export var CartItemsCount = function (_a) {
    var children = _a.children, initialCount = _a.initialCount;
    var _b = useState(initialCount || 0), itemsCount = _b[0], setItemsCount = _b[1];
    var cart = useMemo(function () { return ({ itemsCount: itemsCount }); }, [itemsCount]);
    useSubscribeTo(UPDATE_CART_ITEMS_COUNT, function (count) {
        if (count === void 0) { count = 0; }
        setItemsCount(count);
    });
    return children(cart);
};
export function useUpdateCartItemsCount() {
    return dispatch(UPDATE_CART_ITEMS_COUNT);
}
